var render = function render(){var _vm=this,_c=_vm._self._c;return (null == _vm.current_firmware_id)?_c('span',{staticClass:"ml-0"},[(null == _vm.target_firmware_id)?_c('v-icon',[_vm._v(" mdi-book-off-outline ")]):_c('v-icon',{attrs:{"color":"alert"}},[_vm._v(" mdi-book-clock-outline ")])],1):_c('span',[(null == _vm.target_firmware_id)?_c('span'):_c('span',{staticClass:"ml-0"},[(
        null != _vm.target_firmware_id &&
          null != _vm.current_firmware_id &&
          _vm.target_firmware_id == _vm.current_firmware_id
      )?_c('v-icon',{attrs:{"color":"ok"}},[_vm._v(" mdi-book-check-outline ")]):_c('v-icon',{attrs:{"color":"alert"}},[_vm._v(" mdi-book-clock-outline ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }